import { AuthContext } from "domains/auth/providers/Root/context";
import React from "react";

export const useAuth = () => React.useContext(AuthContext);
export const useIsAdmin = () => !!useAuth().user?.is_gigpro_admin;

const TOKEN_KEY = "token";
export function getTokenSilently(): string | null {
  const itemStr = localStorage.getItem(TOKEN_KEY);

  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);

  if (Date.now() / 1000 > item.expiry) {
    localStorage.removeItem(TOKEN_KEY);
    return null;
  }
  return item.value;
}

export function setValidToken(options: { token: string; seconds?: number }) {
  const defaultValue = { key: TOKEN_KEY, seconds: 2592000 };
  const { key, token, seconds } = { ...defaultValue, ...options };
  const item = {
    value: token,
    expiry: Date.now() / 1000 + seconds,
  };
  localStorage.setItem(key, JSON.stringify(item));
}
